import loadable from '@loadable/component'

export default [
  // 直播数据
  {
    path: '/newAnchorcenter/LiveData',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-LiveData" */ '~/pages/NewAnchorcenter/LiveData'
        )
    ),
  },
  {
    path: '/newAnchorcenter/LiveData/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-LiveDataDetail" */ '~/pages/NewAnchorcenter/LiveDataDetail'
        )
    ),
  },
  {
    path: '/newAnchorcenter/LiveData/sessionDetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-LiveSessionDetail" */ '~/pages/NewAnchorcenter/LiveSessionDetail'
        )
    ),
  },
  {
    path: '/newAnchorcenter/LiveData/query',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-LiveDataQuery" */ '~/pages/NewAnchorcenter/LiveDataQuery'
        )
    ),
  },
  {
    path: '/newAnchorcenter/LiveData/salaryDetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-SalaryDetail" */ '~/pages/NewAnchorcenter/SalaryDetail'
        )
    ),
  },
]
